import {Type} from "class-transformer";
import {serializeType, PaymentType} from "@app/shared";

export class OrgPaymentConfig {
  enableAchPayment?: boolean;
  achConfig?: AchConfig;
  checkConfig?: CheckConfig;
  paymentTypes: PaymentType[];
}

export class AchConfig {
  enableAchPayment?: boolean;
  maxLimitPerTransaction?: number;
}

export class CheckConfig {
  enableCheckPayment?: boolean;
}